import React from "react";
import { Table } from "react-bootstrap";
import { LanguageSetting } from "../../common/Const";
import styled from "styled-components";
import hotelGeoJsonData from "../../geoJson/hotel.json";

type HotelTableProps = {
  handleFilterShow: () => void;
  langSetting: LanguageSetting;
  serchedShopName: string;
  setCenterOfMap: (position: L.LatLngTuple) => void;
  setIsMoveCenter: (isMoveCenter: boolean) => void;
  setPinId: (id: string) => void;
  setZoomOfMap: (magnification: number) => void;
};

const HotelTable: React.FC<HotelTableProps> = ({
  handleFilterShow,
  langSetting,
  serchedShopName,
  setCenterOfMap,
  setIsMoveCenter,
  setPinId,
  setZoomOfMap,
}) => {
  return (
    <StyledTable striped borderless hover variant="dark" size="sm">
      <thead>
        <tr>
          <th>{langSetting === "JA" ? "ホテル名" : "Hotel name"}</th>
        </tr>
      </thead>
      <tbody>
        {hotelGeoJsonData.features
          .filter(
            (a: any) =>
              a.properties.name
                .toLowerCase()
                .indexOf(serchedShopName.toLowerCase()) > -1
          )
          .sort((a: any, b: any) => {
            if (a["properties"]["name"] < b["properties"]["name"]) return 1;
            if (a["properties"]["name"] > b["properties"]["name"]) return -1;
            return 0;
          })
          .map((row) => {
            return (
              <tr
                key={`tr${row.properties.id}`}
                onClick={() => {
                  if (document.querySelectorAll(".leaflet-marker-icon"))
                    document
                      .querySelectorAll(".leaflet-marker-icon")
                      .forEach((e) => e.classList.remove("serched-pin"));
                  setCenterOfMap(
                    row.geometry.coordinates
                      ? [
                          Number(row.geometry.coordinates[1]),
                          Number(row.geometry.coordinates[0]),
                        ]
                      : [14.571649689172614, 120.98437441430472]
                  );
                  setZoomOfMap(19);
                  setIsMoveCenter(true);
                  setPinId(`.Hotel${row.properties.id}`);

                  let e = new Event("click", {
                    bubbles: true,
                    cancelable: true,
                  });
                  let pin = document.querySelector(
                    `img.leaflet-marker-icon.Hotel${row.properties.id}`
                  ) as HTMLElement;
                  if (pin) {
                    pin.classList.add("serched-pin");
                    pin.dispatchEvent(e);
                  }
                  handleFilterShow();
                }}
              >
                <td key={`shopname${row.properties.id}`}>
                  {" "}
                  {row.properties.shopName.split("|||")[0]}
                  <span className="tag-for-search">
                    {row.properties.shopName.split("|||")[1]}
                  </span>
                </td>
              </tr>
            );
          })}
      </tbody>
    </StyledTable>
  );
};
const StyledTable = styled(Table)`
  thead {
    position: sticky;
    top: 0;
    left: 0;
  }
  tbody {
    overflow-x: hidden;
  }
  th {
    font-size: 0.55rem;
    font-weight: 800;
    width: 100px;
  }
  td {
    font-size: 0.6rem;
    width: 100px;
  }
`;

export default HotelTable;
